import React from 'react'

function InputsWarehouse() {
  return (
    <div>InputsWarehouse</div>
  )
}

export default InputsWarehouse